import { ButtonType, ButtonWidget, DialogType, DialogWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { CreateCustomDialogFn, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import { UploadWorkbookStyles } from '../styles/UploadWorkbookStyles';

export interface OverwriteConfirmDialogProps {
  openUploadWorkbookDialog: () => void;
  submitWorkbookUpload: () => void;
  workbookName: string;
  close: () => void;
}
/**
 * Options used for ReactModalService
 */
export function ConfirmOverwriteDialogOpts(props: Omit<OverwriteConfirmDialogProps, 'close'>): CreateCustomDialogFn {
  return (closeAndDismiss) => {
    const dialogProps = ReactModalService.getDefaultDialogProps({
      type: DialogType.NormalWithTitleBar,
      title: Messages.contentUpload_overwriteWorkbook(),
      showCloseButton: false,
      dialogWidth: 400,
      shouldNotCloseOnGlassClick: true,
      testId: 'upload-workbook-overwrite-confirmation'
    }, closeAndDismiss);

    return (
      <DialogWidget {...dialogProps}>
        <OverwriteConfirmDialog
          openUploadWorkbookDialog={props.openUploadWorkbookDialog}
          submitWorkbookUpload={props.submitWorkbookUpload}
          workbookName={props.workbookName}
          close={closeAndDismiss.close}
        />,
      </DialogWidget>
    );
  };
}

export class OverwriteConfirmDialog extends React.PureComponent<OverwriteConfirmDialogProps> {

  private handleSubmit = (): void =>  {
    this.props.submitWorkbookUpload();
    this.props.close();
  }

  private handleCancel = (): void =>  {
    this.props.openUploadWorkbookDialog();
    this.props.close();
  }

  render() {
    return (
    <div>
        {Messages.contentUpload_confirmOverwriteWarning({WORKBOOK_NAME:this.props.workbookName})}

        <footer className={UploadWorkbookStyles.footer}>
          <ButtonWidget
            buttonType={ButtonType.Outline}
            testId={'confirm-overwrite-dialog-cancel'}
            children={Messages.cancel()}
            handleClick={this.handleCancel}
          />
          <ButtonWidget
            buttonType={ButtonType.Primary}
            testId={'confirm-overwrite-dialog-submit'}
            children={Messages.contentUpload_overwrite()}
            handleClick={this.handleSubmit}
          />
        </footer>
      </div>
    );
  }
}
